<template>
  <div>
    <div class="top-breadcrumb">
      <ol class="breadcrumb" style="background-color: white">
        <li class="breadcrumb-item" style="margin-left: 15px">
          <router-link to="" style="color: #8cc63f !important">
            Portfolio Management
          </router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link
            style="color: #8cc63f !important"
            :to="'/' + authUser.userable_type + '/plans'"
            >Plans</router-link
          >
        </li>
        <li class="breadcrumb-item">
          <router-link
            style="color: #8cc63f !important"
            :to="'/' + authUser.userable_type + '/plan/' + activePlanID"
            >{{ activePlan.name }}</router-link
          >
        </li>
      </ol>
    </div>
    <spinner style="margin-top: 60px" v-if="searchingPlan" />

    <div
      v-else
      style="
        display: flex;
        align-items: center;
        flex-direction: column;
        margin-bottom: 50px;
        margin-top: 60px;
      "
    >
      <div class="col-10">
        <md-card
          class="md-card-stats"
          style="
            min-height: 75px;
            border-radius: 50px;
            display: flex;
            align-items: center;
            flex-direction: row !important;
          "
        >
          <div style="padding-left: 50px; font-size: 18px" class="col-6">
            {{ activePlan.code }} - {{ activePlan.name }}
          </div>
          <div class="col-6" style="text-align: end; padding-right: 50px">
            <button
              style="border-radius: 30px; padding: 6px 12px; margin-right: 10px"
              type="button"
              class="btn btn-warning"
              @click="redirectToUpdatePlan()"
            >
              <i
                style="padding-top: 5px; color: white"
                class="fa fa-arrow-up"
              ></i>
            </button>
            <button
              style="border-radius: 30px; padding: 6px 12px"
              @click="deletePlan()"
              type="button"
              class="btn btn-danger"
            >
              <i style="padding-top: 5px" class="fa fa-trash"></i>
            </button>
          </div>
        </md-card>
      </div>

      <div class="col-10">
        <md-card
          class="md-card-stats"
          style="
            border-top-right-radius: 30px;
            border-top-left-radius: 30px;
            display: flex;
            justify-content: center;
            margin-bottom: 15px;
          "
        >
          <div
            style="
              display: flex;
              align-items: center;
              flex-direction: row !important;
              min-height: 75px;
            "
          >
            <div
              style="
                padding-left: 50px;
                font-size: 18px;
                display: flex;
                align-items: center;
                cursor: pointer;
              "
              @click="togglePlanDetails()"
              class="col-6"
            >
              Plan Details
              <i
                style="font-size: 10px; padding-left: 20px"
                :class="showPlanDetails ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"
              ></i>
            </div>
          </div>
          <div
            :style="showPlanDetails ? 'display: block' : 'display: none'"
            style="min-height: 100px"
          >
            <div class="col-12 planInfoClass">
              <label
                class="col-2"
                style="padding: 0; font-size: 13px; font-weight: bold"
                >Code</label
              >
              <label style="line-height: normal" class="col-10">
                {{ activePlan.code }}
              </label>
            </div>
            <div class="col-12 planInfoClass">
              <label
                class="col-2"
                style="padding: 0; font-size: 13px; font-weight: bold"
                >Description</label
              >
              <label style="line-height: normal" class="col-10">
                {{ activePlan.description }}
              </label>
            </div>
            <div class="col-12 planInfoClass">
              <label
                class="col-2"
                style="padding: 0; font-size: 13px; font-weight: bold"
                >Minimum Principle</label
              >
              <label style="line-height: normal" class="col-10">
                ${{ activePlan.min_principal.toLocaleString() }}
              </label>
            </div>
            <div class="col-12 planInfoClass">
              <label
                class="col-2"
                style="padding: 0; font-size: 13px; font-weight: bold"
                >Maximum Principle</label
              >
              <label style="line-height: normal" class="col-10">
                ${{ activePlan.max_principal.toLocaleString() }}
              </label>
            </div>
            <div class="col-12 planInfoClass">
              <label
                class="col-2"
                style="padding: 0; font-size: 13px; font-weight: bold"
                >Minimum Period</label
              >
              <label style="line-height: normal" class="col-10">
                {{ activePlan.min_period }}
                {{
                  activePlan.period.charAt(0).toUpperCase() +
                  activePlan.period.slice(1)
                }}
              </label>
            </div>
            <div class="col-12 planInfoClass">
              <label
                class="col-2"
                style="padding: 0; font-size: 13px; font-weight: bold"
                >Withdrawal Notice</label
              >
              <label style="line-height: normal" class="col-10">
                {{ activePlan.withdrawal_notice }}
                {{
                  activePlan.withdrawal_notice_period.charAt(0).toUpperCase() +
                  activePlan.withdrawal_notice_period.slice(1)
                }}
                Notice
              </label>
            </div>
            <div class="col-12 planInfoClass">
              <label
                class="col-2"
                style="padding: 0; font-size: 13px; font-weight: bold"
                >Estimated ROI</label
              >
              <label style="line-height: normal" class="col-10">
                {{ activePlan.est_roi }} %
              </label>
            </div>
          </div>
        </md-card>
      </div>
      <div class="col-10">
        <md-card
          class="md-card-stats"
          style="
            display: flex;
            justify-content: center;
            margin: 0;
            margin-bottom: 15px !important;
          "
        >
          <div
            style="
              display: flex;
              align-items: center;
              flex-direction: row !important;
              min-height: 75px;
            "
          >
            <div
              style="
                padding-left: 50px;
                font-size: 18px;
                display: flex;
                align-items: center;
                cursor: pointer;
              "
              @click="togglePlanAllocation()"
              class="col-6"
            >
              Plan Allocation
              <i
                style="font-size: 10px; padding-left: 20px"
                :class="
                  showPlanAllocation ? 'fa fa-arrow-up' : 'fa fa-arrow-down'
                "
              ></i>
            </div>
          </div>
          <div
            :style="
              showPlanAllocation && activePlan.allocation_type == 'clusters'
                ? 'display: block'
                : 'display: none'
            "
            style="min-height: 100px"
          >
            <div
              class="col-12 planInfoClass"
              v-for="(cluster_weight, key) in activePlan.cluster_weights"
              :key="key"
            >
              <label
                class="col-2"
                style="padding: 0; font-size: 13px; font-weight: bold"
                >{{ cluster_weight.clusterName }}</label
              >
              <label style="line-height: normal" class="col-10">
                {{ cluster_weight.weight }}%
              </label>
            </div>
          </div>
          <div
            :style="
              showPlanAllocation && activePlan.allocation_type == 'projects'
                ? 'display: block'
                : 'display: none'
            "
            style="min-height: 100px"
          >
            <div
              class="col-12 planInfoClass"
              v-for="(project_weight, key) in activePlan.project_weights"
              :key="key"
            >
              <label
                class="col-2"
                style="padding: 0; font-size: 13px; font-weight: bold"
                >{{ project_weight.projectName }}</label
              >
              <label style="line-height: normal" class="col-10">
                {{ project_weight.weight }}%
              </label>
            </div>
          </div>
        </md-card>
      </div>
      <div class="col-10">
        <md-card
          class="md-card-stats"
          style="
            display: flex;
            justify-content: center;
            margin: 0;
            margin-bottom: 15px !important;
          "
        >
          <div
            style="
              display: flex;
              align-items: center;
              flex-direction: row !important;
              min-height: 75px;
            "
          >
            <div
              style="
                padding-left: 50px;
                font-size: 18px;
                display: flex;
                align-items: center;
                cursor: pointer;
              "
              @click="togglePlanReports()"
              class="col-6"
            >
              Plan Reports
              <i
                style="font-size: 10px; padding-left: 20px"
                :class="showPlanReports ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"
              ></i>
            </div>
            <div
              style="
                padding-right: 20px;
                font-size: 18px;
                display: flex;
                justify-content: end;
                align-items: center;
                cursor: pointer;
              "
              class="col-6"
            >
              <button
                style="
                  border-radius: 30px;
                  padding: 6px 12px;
                  margin-right: 10px;
                  background-color: #8cc63f;
                  border-color: #8cc63f;
                "
                type="button"
                class="btn btn-info"
                @click="toggleCreatePlanReportModal()"
              >
                <i
                  style="padding-top: 5px; color: white"
                  class="fa fa-plus"
                ></i>
              </button>
            </div>
          </div>
          <div
            :style="showPlanReports ? 'display: block' : 'display: none'"
            style="min-height: 100px"
          >
            <div class="col-12 planInfoClass" style="padding-bottom: 25px">
              <table style="width: 100%">
                <thead>
                  <tr style="text-align: center">
                    <th>Year</th>
                    <th>Summary</th>
                    <th>ROI(%)</th>
                    <th>Grade</th>
                    <th>Status</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    style="text-align: center"
                    v-for="(report, key) in activePlanReports"
                    :key="key"
                  >
                    <td>{{ report.year }}</td>
                    <td style="width: 400px">
                      {{
                        report.summary.length > 150
                          ? report.summary.substring(0, 150) + "..."
                          : report.summary.length
                      }}
                    </td>
                    <td>{{ fixNumberView(report.roi) }}</td>
                    <td>{{ report.grade }}</td>
                    <td>
                      {{
                        report.status.charAt(0).toUpperCase() +
                        report.status.slice(1)
                      }}
                    </td>
                    <td>
                      <a
                        style="
                          color: rgb(140, 198, 63) !important;
                          cursor: pointer;
                        "
                        @click="toggleUpdatePlanReportModal(report)"
                      >
                        <i class="fa fa-edit"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </md-card>
      </div>
      <div class="col-10">
        <md-card
          class="md-card-stats"
          style="
            display: flex;
            justify-content: center;
            margin: 0;
            border-bottom-right-radius: 30px;
            border-bottom-left-radius: 30px;
          "
        >
          <div
            style="
              display: flex;
              align-items: center;
              flex-direction: row !important;
              min-height: 75px;
            "
          >
            <div
              style="
                padding-left: 50px;
                font-size: 18px;
                display: flex;
                align-items: center;
                cursor: pointer;
              "
              @click="togglePlanFiles()"
              class="col-6"
            >
              Plan Files
              <i
                style="font-size: 10px; padding-left: 20px"
                :class="showPlanFiles ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"
              ></i>
            </div>
          </div>
          <div
            :style="showPlanFiles ? 'display: block' : 'display: none'"
            style="min-height: 100px"
          >
            <div class="col-12 planInfoClass" style="padding-bottom: 25px">
              <table style="width: 100%">
                <thead>
                  <tr style="text-align: center">
                    <th>#</th>
                    <th>File Name</th>
                    <th>File Type</th>
                    <th>File Size</th>
                    <th>Download</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    style="text-align: center"
                    v-for="(file, key) in activePlan.files"
                    :key="key"
                  >
                    <td>{{ key + 1 }}</td>
                    <td>
                      {{
                        file.plan_file.caption.split(".").slice(0, -1).join(".")
                      }}
                    </td>
                    <td>{{ file.plan_file.extension }}</td>
                    <td>{{ bytesToSize(file.plan_file.size) }}</td>
                    <td>
                      <a
                        style="color: rgb(140, 198, 63) !important"
                        :href="file.plan_file.url"
                        target="_blank"
                        download
                      >
                        <i class="fa fa-download"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </md-card>
      </div>
    </div>
    <plan-report-modal
      :active="showPlanReportModal"
      :actionType="actionModalType"
      :activePlanReport="activePlanReport"
      @saveRequest="handlePlanReportSave"
      @closeRequest="
        actionModalType == 'createModal'
          ? toggleCreatePlanReportModal()
          : toggleUpdatePlanReportModal()
      "
    />
  </div>
</template>
<script>
import Spinner from "vue-simple-spinner";
import sweetAlert from "sweetalert2";
import { mapState } from "vuex";
import PlansFilter from "../../filters/PlansFilter";
import PlanReportsFilter from "../../filters/PlanReportsFilter";
import PlanReportModal from "./components/modals/planReportModal.vue";
export default {
  name: "plan",
  data() {
    return {
      showPlanDetails: false,
      showPlanAllocation: false,
      showPlanReports: false,
      showPlanFiles: false,
      showPlanReportModal: false,
      activePlanID: null,
      actionModalType: null,
      showPlanReportModal: false,
      activePlanReport: null,
    };
  },
  created: function () {
    this.activePlanID = this.$route.params.planId;
    var plansFilter = PlansFilter();
    plansFilter.ids = [this.activePlanID];
    plansFilter.with = ["files", "clusterWeights", "projectWeights"];
    this.$store.dispatch("searchPlans", {
      filter: plansFilter,
      resultMode: "default",
    });

    var planReportsFilter = PlanReportsFilter();
    planReportsFilter.plan_ids = [this.activePlanID];
    planReportsFilter.orderBy = ["year", "asc"];
    this.$store.dispatch("searchPlanReports", {
      filter: planReportsFilter,
      resultMode: "default",
    });
  },
  components: {
    Spinner,
    PlanReportModal,
  },
  computed: {
    ...mapState({
      authUser: (state) => state.userStore.authUser,
      activePlan: (state) => state.planStore.planSearch.plans[0],
      activePlanReports: (state) =>
        state.planReportStore.planReportSearch.planReports,
      createPlanReportStatus: (state) =>
        state.planReportStore.planReportCreate.createPlanReportStatus,
      updatePlanReportStatus: (state) =>
        state.planReportStore.planReportUpdate.updatePlanReportStatus,
      deletePlanStatus: (state) => state.planStore.planDelete.deletePlanStatus,
      searchingPlan: (state) => state.planStore.planSearch.searchingPlans,
    }),
  },
  methods: {
    togglePlanDetails() {
      this.showPlanDetails = !this.showPlanDetails;
    },
    togglePlanAllocation() {
      this.showPlanAllocation = !this.showPlanAllocation;
    },
    togglePlanReports() {
      this.showPlanReports = !this.showPlanReports;
    },
    togglePlanFiles() {
      this.showPlanFiles = !this.showPlanFiles;
    },
    bytesToSize(bytes) {
      var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
      if (bytes === 0) return "0 Byte";
      var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
      return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
    },
    fixNumberView(value) {
      const numFor = Intl.NumberFormat("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      });
      return value < 0
        ? "(" + Math.abs(value).toLocaleString() + ")"
        : numFor.format(value);
    },
    redirectToUpdatePlan() {
      this.$router.push(
        "/" +
          this.authUser.userable_type +
          "/plan/" +
          this.activePlan.name +
          "/update/" +
          this.activePlan.id
      );
    },
    handlePlanReportSave(planReport) {
      if (this.actionModalType == "createModal") {
        planReport.plan_id = this.activePlan.id;
        this.$store.dispatch("createPlanReport", planReport);
      } else {
        planReport.plan_id = this.activePlan.id;
        this.$store.dispatch("updatePlanReport", planReport);
      }
      var planReportsFilter = PlanReportsFilter();
      planReportsFilter.plan_ids = [this.activePlanID];
      planReportsFilter.orderBy = ["year", "asc"];
      this.$store.dispatch("searchPlanReports", {
        filter: planReportsFilter,
        resultMode: "default",
      });
      this.showPlanReportModal = false;
    },
    deletePlan() {
      sweetAlert({
        title: "Confirmation",
        text: "Are you sure you want to delete this plan?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.value) {
          this.$store.dispatch("deletePlan", this.activePlan.id);
        }
      });
    },
    toggleCreatePlanReportModal() {
      this.showPlanReportModal = !this.showPlanReportModal;
      this.showPlanReportModal ? (this.actionModalType = "createModal") : null;
    },
    toggleUpdatePlanReportModal(cluster) {
      this.showPlanReportModal = !this.showPlanReportModal;
      if (this.showPlanReportModal) {
        this.actionModalType = "updateModal";
        this.activePlanReport = cluster;
      } else {
        this.actionModalType = null;
        this.activePlanReport = null;
      }
    },
  },
  watch: {
    createPlanReportStatus() {
      if (this.createPlanReportStatus == "success") {
        sweetAlert({
          title: "Success",
          text: "Plan report has been created successfully",
          icon: "success",
          confirmButtonText: "Done",
        }).then(() => {
          this.init();
        });
      } else if (this.createPlanReportStatus == "failed") {
        sweetAlert({
          title: "Failed",
          text: "Plan report creation has failed",
          IntersectionObserver: "error",
          confirmButtonText: "Return",
        });
      }
    },
    updatePlanReportStatus() {
      if (this.updatePlanReportStatus == "success") {
        sweetAlert({
          title: "Success",
          text: "Plan report has been updated successfully",
          icon: "success",
          confirmButtonText: "Done",
        }).then(() => {
          this.init();
        });
      } else if (this.updatePlanReportStatus == "failed") {
        sweetAlert({
          title: "Failed",
          text: "Plan report update has failed",
          IntersectionObserver: "error",
          confirmButtonText: "Return",
        });
      }
    },
    deletePlanStatus() {
      if (this.deletePlanStatus == "success") {
        sweetAlert({
          title: "Success",
          text: "Plan has been deleted successfully",
          icon: "success",
          confirmButtonText: "Done",
        }).then(() => {
          this.$router.push("/" + this.authUser.userable_type + "/plans");
        });
      } else if (this.deletePlanStatus == "failed") {
        sweetAlert({
          title: "Failed",
          text: "Plan delete has failed",
          IntersectionObserver: "error",
          confirmButtonText: "Return",
        });
      }
    },
  },
};
</script>
<style>
.planInfoClass {
  padding-left: 75px;
  display: flex;
  align-items: start;
}
</style>


// WEBPACK FOOTER //
// resources/js/pages/admin/plan.vue